export default __webpack_public_path__ + "static/haddock-b3176a958b13fc16d151636144c8fae0.jpeg";